import { useEffect, useMemo, useState } from "react";
import WithAuth from "../../hoc/WithAuth";
import UsersTable from "../../components/tables/users/UsersTable";

import { useGetUserStatusCount, useMyUsersList } from "../../api/users";

function UsersPage() {
  const [searchText, setSearchText] = useState("");
  const [activeFilter, setActiveFilter] = useState<string>("all");
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [countAll, setCountAll] = useState<number>(0);

  /** API */
  const { data: myUsers, isLoading } = useMyUsersList({
    status: activeFilter === "all" ? undefined : activeFilter.toUpperCase(),
    search: searchText || undefined,
    page: currentPage - 1,
    size: pageSize,
  });
  const { data: statuses } = useGetUserStatusCount();

  /** Handlers */
  const handlePaginationChange = (page: number, size: number) => {
    setCurrentPage(page);
    setPageSize(size);
  };

  const handleFilterChange = (filter: string) => {
    setActiveFilter(filter);
    setCurrentPage(1);
  };

  /** Filter counts */
  const filterCounts = useMemo(() => {
    const statusData = statuses?.data?.data;
    return {
      all: myUsers?.data?.totalElements || 0,
      active: statusData?.active || 0,
      inActive: statusData?.inActive || 0,
    };
  }, [myUsers?.data?.totalElements, statuses?.data?.data]);

  useEffect(() => {
    if (activeFilter === "all") setCountAll(myUsers?.data?.totalElements || 0);
  }, [activeFilter, myUsers?.data?.totalElements]);

  return (
    <div className="py-5">
      <UsersTable
        allUsers={myUsers?.data?.content}
        totalElements={myUsers?.data?.totalElements}
        isLoading={isLoading}
        searchText={searchText}
        onSearchChange={setSearchText}
        activeFilter={activeFilter}
        onFilterChange={handleFilterChange}
        currentPage={currentPage}
        onPageChange={handlePaginationChange}
        filterCounts={filterCounts}
        pageSize={pageSize}
        countAll={countAll}
      />
    </div>
  );
}

export default WithAuth(UsersPage);
